var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTearInner = function SvgTearInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 34,
    viewBox: "0 0 0.77 0.7",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.26.34C.23.31.24.61.24.66c0 .08.2.02.27.03C.54.66.53.37.53.31.43.33.47.39.28.33.27.32.26.33.26.34z",
    fill: "#00f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.71.22C.74.21.64.14.6.12.36-.02.25.07.05.23c.2.16.39.16.66-.01z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgTearInner;